import React, { useEffect } from "react";
import { Route, BrowserRouter, Switch } from "react-router-dom";
import "./App.css";
import Prefixs from "./common/Prefixs";
import GatewayCompoment from "./components";
import Expires from "./components/error/Expires";
import Notfound from "./components/error/Notfound";
import LockCertificate from "./components/lockcertificate";

import NotificationExtend from "./components/notification/extend";
import NotificationDoc from "./components/notification/notenoughdoc";
import ResetPin from "./components/tms/resetpin";
import Extend from "./components/tms/service/extend";
import Register from "./components/tms/service/register";
import ChangeInfo from "./components/tms/support/changeinfo";
import ConfirmChangeInfo from "./components/tms/support/changeinfo/ConfirmChangeInfo";
import Request from "./components/tms/support/request";
import Unlock from "./components/unlock";
import ResetPinSuccess from "./components/unlock/ResetPinSuccess";
import Header from "./components/header";
import ViewTutorial from "./components/header/ViewTutorial";
import GloabalConst from "./common/GloabalConst";
import ViewTutorialType from "./common/ViewTutorialType";
import LookUpSupport from "./pages/look-up-support/LookUpSupport";
import SupportInfoAdd from "./pages/support-info/SupportInfoAdd";
import ReNewCert from "./pages/renewcert";
import ReNewCertInfo from "./pages/renewcert/viewinforrenew";
import OrderPayment from "pages/order-payment/OrderPayment";
import DefaultLayout from "layouts";
import CompensationExtend from "pages/CompensationExtend";
import ReNewCertError from "pages/renewcert/ReNewCertError";
import PublicCapBu from "./pages/public-capbu";

const loadingDemo = (
  <div
    style={{
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    Đang tải...
  </div>
);

function App() {
  useEffect(() => {
    const path = window.location.pathname;
    const container = document.querySelector("#root");
    if (path === "/tutorial" && container) {
      container.classList.add("no-flex");
    } else if (container) {
      container.classList.remove("no-flex");
    }
  }, []);
  useEffect(() => {
    localStorage.setItem(GloabalConst.VIEW_TUTORIAL, ViewTutorialType.DISPLAY);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <BrowserRouter>
      <React.Suspense fallback={loadingDemo}>
        <Switch>
          <Route
            exact
            path={Prefixs.TOKEN_GATEWAY}
            render={() => (
              <>
                <Header />
                <GatewayCompoment />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.LOCK_UNPAID}
            render={() => (
              <>
                <Header />
                <LockCertificate />
              </>
            )}
          />{" "}
          <Route
            path={Prefixs.LOCK_NOT_ENOUGH_DOC}
            render={() => (
              <>
                <Header />
                <LockCertificate />
              </>
            )}
          />{" "}
          <Route
            path={Prefixs.RENEWCERT}
            render={() => (
              <>
                <Header />
                <ReNewCert />
              </>
            )}
          />{" "}
            <Route
                path={Prefixs.PATH_PUBLIC_CAPBU}
                render={() => (
                    <>
                        <Header />
                        <PublicCapBu />
                    </>
                )}
            />{" "}

          <Route
            path={Prefixs.RENEWCERT_ERROR}
            render={() => (
              <>
                <DefaultLayout>
                  <ReNewCertError />
                </DefaultLayout>
              </>
            )}
          />{" "}
          <Route
            path={Prefixs.RENEWCERT_INFO}
            render={() => (
              <>
                <Header />
                <ReNewCertInfo />
              </>
            )}
          />{" "}
          <Route
            path={Prefixs.LOCK_REVOKE}
            render={() => (
              <>
                <Header />
                <LockCertificate />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.LOCK_WRONG_PIN}
            render={() => (
              <>
                <Header />
                <LockCertificate />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.LOCK_AUTHEN}
            render={() => (
              <>
                <Header />
                <LockCertificate />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.EXPIRES}
            render={() => (
              <>
                <Expires />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.NOTFOUND}
            render={() => (
              <>
                <Header />
                <Notfound />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.RESET_PIN_AUTHENTICATED}
            render={() => (
              <>
                <Header />
                <ResetPin />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.SUPPORT_CHANGE_INFO}
            render={() => (
              <>
                <DefaultLayout>
                  <ChangeInfo />
                </DefaultLayout>
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.SUPPORT_CHANGE_INFO_CONFIRM}
            render={() => (
              <>
                <Header />
                <ConfirmChangeInfo />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.SUPPORT_REQUEST}
            render={() => (
              <>
                <Header />
                <Request />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.UNLOCK_SUCCSES}
            render={() => (
              <>
                <Header />
                <Unlock />
              </>
            )}
          />{" "}
          <Route
            path={Prefixs.NOTI_NOT_ENOUGH_DOC}
            render={() => (
              <>
                <Header />
                <NotificationDoc />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.NOTI_EXTEND}
            render={() => (
              <>
                <Header />
                <NotificationExtend />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.SERVICE_REGISTER}
            render={() => (
              <>
                <Header />
                <Register />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.SERVICE_EXTEND}
            render={() => (
              <>
                <Header />
                <Extend />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.RESET_PIN_SUCCSES}
            render={() => (
              <>
                <Header />
                <ResetPinSuccess />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.LOOK_UP_SUPPORT}
            render={() => (
              <>
                <LookUpSupport />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.SUPPORT_ADD_INFO}
            render={() => (
              <>
                <SupportInfoAdd />
              </>
            )}
          />{" "}
          <Route
            exact
            path={Prefixs.VIEW_FILE_TUTORIAL}
            component={ViewTutorial}
          />{" "}
          <Route
            exact
            path={Prefixs.ORDER_PAYMENT}
            render={() => (
              <>
                <DefaultLayout>
                  <OrderPayment />
                </DefaultLayout>
              </>
            )}
          />
          <Route
            exact
            path={Prefixs.COMPENSATION_EXTEND}
            render={() => (
              <>
                <DefaultLayout>
                  <CompensationExtend />
                </DefaultLayout>
              </>
            )}
          />
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  );
}

export default App;
